import React, { Component, useEffect } from 'react'
import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  PointElement,
  LineElement,
  Title,
  Tooltip,
  Legend,
} from 'chart.js';
import { Line } from 'react-chartjs-2';
import { useApplicationStore } from '../../stores/applicationStore';
import moment from 'moment';
import { useTranslation } from 'react-i18next';


ChartJS.register(
  CategoryScale,
  LinearScale,
  PointElement,
  LineElement,
  Title,
  Tooltip,
  Legend
);

export const options = {
  responsive: true,
  plugins: {

    legend: {
      labels: {
        font: {
          size: 11
        },
        usePointStyle: true,
        fill: false,
        pointStyle: 'rectRounded',
        padding: 10,
        pointStyleWidth: 32,
        borderRadius: 36,
        borderWidth: 0,
        borderJoinStyle: 'bevel',
      }
    },

    title: {
      display: false,
      text: 'Activities',
    },
  },
};


const ChartActivities: React.FC = () => {
  const applicationStore = useApplicationStore();
  const [labels, setLabels] = React.useState(Array.from({ length: 12 }, (_, i) => moment().subtract(i, 'months').format('MMM')).reverse());
  const [data, setData] = React.useState<{ labels: string[], datasets: { label: string, data: number[], fill: boolean, borderColor: string, backgroundColor: string, tension: number, borderWidth: number, pointRadius: number, pointHoverRadius: number }[] }>({ labels: [], datasets: [] });
  const { t } = useTranslation(); // useTranslation hook'unu kullanarak 't' fonksiyonuna eriş

  useEffect(() => {
    const numberOfApplications = labels.map(label => applicationStore.applications.filter(application => moment(application.createdAt).format('MMM') === label).length);
    const numberOfApprovals = labels.map(label => applicationStore.applications.filter(application => moment(application.createdAt).format('MMM') === label && application.status === 'approved').length);
    const numberOfRejections = labels.map(label => applicationStore.applications.filter(application => moment(application.createdAt).format('MMM') === label && application.status === 'rejected').length);

    const data = {
      labels,
      datasets: [
        {
          label: t('applications'),
          data: numberOfApplications,
          fill: false,
          borderColor: '#0f73b7',
          backgroundColor: '#0f73b7',
          tension: 0.1,
          borderWidth: 2,
          pointRadius: 4,
          pointHoverRadius: 8,
        },
        {
          label: t('approvals'),
          data: numberOfApprovals,
          fill: false,
          borderColor: 'rgb(75, 192, 192) ',
          backgroundColor: 'rgb(75, 192, 192) ',
          tension: 0.1,
          borderWidth: 2,
          pointRadius: 4,
          pointHoverRadius: 8,
        },
        {
          label: t('rejections'),
          data: numberOfRejections,
          fill: false,
          borderColor: '#db2db7',
          backgroundColor: '#db2db7',
          tension: 0.1,
          borderWidth: 2,
          pointRadius: 4,
          pointHoverRadius: 8,
        },
      ],
    };
    setData(data);
  }, [applicationStore]);

  return (
    <div className="card-block card-block-02">
      <h2 className="card-title">{t('applicationActivities')}</h2>
      <div className="card-content">
        <Line options={options} data={data} />
      </div>
    </div>
  );
};

export default ChartActivities;
